import * as React from 'react';
import useLabelTranslation from 'src/hooks/useLabelTranslation';
import css from './side-menu-new-badge.css';


export const BetaBadge = (): React.ReactElement => {
  const {t} = useLabelTranslation();
  return (
    <span className={css.newBadge} id="side-nav-byod-beta-label">
      {t('Beta', 'Beta')}
    </span>
  );
};
